import {
  Text,
} from '@chakra-ui/react';
import Chart from 'react-apexcharts';
import {
  useRoadingAssets,
} from '@src/modules/performance/context/reports-api-hooks';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Valuation',
  content: [
    {
      title: 'Roading assets',
      description:
  <Text fontSize="inherit" mb={2}>
    The annual reported book value (Carrying Amount) of the roading network/assets and where available an estimated total cost to replace the roading network/assets (Replacement Cost). In some cases, the estimated replacement cost amount might be to replace based on the fair value amount rather than rebuild new. Where possible, excludes the value of the land under roads. Road Efficiency Group Te Ringa Maimoa has extracted the TA information and amounts from the TA&apos;s published Annual Reports, and has received the State Highways valuation data from NZTA.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Results published in the Territorial Authority annual report for the financial year.
  </Text>,
    },
  ],
};

function TransportProgrammeDeliveryValuation() {
  const { data, isLoading } = useRoadingAssets();
  const lockYear = data?.[0]?.ReportYear || null;

  const distinctYears = [...new Set(data?.map((item) => item.Year))];
  const chartData = [{
    name: 'Total estimated replacement cost',
    type: 'line',
    data: data?.map((item) => ({ x: item.Year, y: item.TotalReplacementValuation ? item.TotalReplacementValuation / 1000000 : null })),
    color: CHART_COLOURS.blue,
  },
  {
    name: 'Carrying amount',
    type: 'line',
    data: data?.map((item) => ({ x: item.Year, y: item.DepreciatedReplacementCost ? item.DepreciatedReplacementCost / 1000000 : null })),
    color: CHART_COLOURS.black,
  },
  ];

  return (
    <ReportSection
      title="Valuation"
      informationSource={informationSource}
      isLoading={isLoading || !data}
      lockYear={lockYear}
    >
      <Chart
        options={
          {
            title: {
              text: 'Roading assets',
            },
            chart: {
              animations: {
                enabled: false,
              },
            },
            xaxis: {
              categories: distinctYears,
              labels: {
                offsetY: 5,
                rotate: -45,
                rotateAlways: true,
              },
            },
            yaxis: [
              {
                forceNiceScale: true,
                labels: {
                  formatter(y) {
                    return `${y.toLocaleString('en-NZ', {
                      style: 'currency',
                      currency: 'NZD',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).replace('NZD', '')}M`;
                  },
                },
              },
            ],
            grid: {
              padding: {
                left: 20,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'straight',
              width: distinctYears.length > 1 ? 2 : 0,
            },
            tooltip: {
              shared: false,
              intersect: true,
              y: {
                formatter(value) {
                  return `${value.toLocaleString('en-NZ', {
                    style: 'currency',
                    currency: 'NZD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 1,
                  }).replace('NZD', '')}M`;
                },
              },
            },
          }
        }
        series={chartData}
        type="line"
        width="280"
        height="280"
      />
    </ReportSection>
  );
}

export default TransportProgrammeDeliveryValuation;
